import Footer from "@/components/Footer";
import HBLogo from "@/components/HBLogo";

/**
 *
 * @param {{children, style: import("react").CSSProperties}} props
 * @returns
 */
export default function PageBg({ children, style = {} }) {
  return (
    <div
      style={{
        backgroundImage: `url(https://st0.dancf.com/static/02/202204191115-7bba.jpg)`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        height: "100vh",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
/**
 * 登录注册重置密码等共用背景
 */
export function AuthBgWrap({ children, noLogo = false }) {
  return (
    <PageBg>
      <PageBg
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {!noLogo && (
          <>
            <HBLogo height={30} width={100} hasText />
            <span
              style={{
                padding: "12px 0 36px",
                fontSize: "20px",
                fontWeight: "300",
              }}
            >
              陪你做生活的设计师
            </span>
          </>
        )}
        {children}
        <Footer></Footer>
      </PageBg>
    </PageBg>
  );
}
